import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Menu, MenuItem } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import instance from 'connection/instance';
import { downloadFile, turnOffEvent } from 'utils/helpers';

const DocumentOptions = (props) => {
  // prettier-ignore
  const { orderItem, orderCode, orderItem: { reservation = {} }, ...other } = props;

  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  // prettier-ignore
  const documents = [
    (orderItem['voucher'] && ['booked', 'confirmed', 'pending_for_refund', 'in_refund'].includes(reservation['state']) && {
      url: orderItem['voucher']?.['file_url'],
      label: t('Orders.DownloadVoucher'),
      title: `${t('Orders.Voucher')} ${orderCode}`,
    }),
  ].filter(i => !!i);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLoadFile = (option) => (e) => {
    turnOffEvent(e);
    instance
      .get(option.url, { responseType: 'blob' })
      .then((response) => downloadFile(response, option.title))
      .then(() => setAnchorEl(null))
      .catch((error) => console.error(error));
  };

  if (!documents?.length) {
    return null;
  }

  return (
    <Grid item>
      <Button
        {...other}
        size="small"
        color="primary"
        variant="contained"
        onClick={handleClick}
        endIcon={<MoreHorizIcon />}
        children={t('Actions.DownloadDocs')}
      />
      <Menu keepMounted anchorEl={anchorEl} onClose={() => setAnchorEl(null)} open={Boolean(anchorEl)}>
        {documents?.map((option, key) => (
          <MenuItem {...{ key }} onClick={handleLoadFile(option)} children={option.label} />
        ))}
      </Menu>
    </Grid>
  );
};

DocumentOptions.propTypes = {
  orderCode: PropTypes.string,
  passenger: PropTypes.object,
  orderItem: PropTypes.object,
};

DocumentOptions.defaultProps = {
  passenger: {},
};

export default DocumentOptions;
